import { Component, inject, signal } from '@angular/core';
import { ButtonComponent } from '../../../shared-with-client/button/button.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NewModalBodyComponent } from '../../../shared/new-modal-body/new-modal-body.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { StoresService } from '../../../core/services/stores.service';
import { DialogRef } from '@angular/cdk/dialog';
import { InvoiceStatus, InvoicingService } from '../../../core/services/invoicing.service';
import { IconComponent } from '../../../shared-with-client/icon/icon.component';
import { Router } from '@angular/router';
import { ToastNotificationsService } from '../../../core/services/toast-notifications.service';

@Component({
    selector: 'app-replace-sale-modal',
    imports: [ButtonComponent, TranslatePipe, NewModalBodyComponent, IconComponent],
    templateUrl: './replace-sale-modal.component.html',
    styleUrl: './replace-sale-modal.component.scss',
})
export class ReplaceSaleModalComponent {
    private storesService = inject(StoresService);
    private invoicingService = inject(InvoicingService);
    private toastNotificationsService = inject(ToastNotificationsService);
    private translateService = inject(TranslateService);
    public isInvoicingActive = toSignal(this.storesService.isInvoicingActive());
    public dialogRef = inject(DialogRef<any>);
    public router = inject(Router);


    public existingSalePreview = toSignal(this.invoicingService.existingSalePreview$);

    public invoicingPatient = toSignal(this.invoicingService.invoicingPatient$);
    public cart = toSignal(this.invoicingService.invoicingCart$);
    public currentStore = toSignal(this.storesService.getActiveStore());

    InvoiceStatus = InvoiceStatus;

    public saving = signal<boolean>(false);


    close(): void {
        this.dialogRef.close();
    }

    continue() {

        this.saving.set(true);
        const patientCopy = this.invoicingPatient() ? { ...this.invoicingPatient() } : null;
        const cartCopy = this.cart() ? { ...this.cart() } : null;



        this.invoicingService.cancelSale(this.existingSalePreview().id, this.currentStore().id, 'replace_invoice').subscribe({
            next: () => {
                this.toastNotificationsService.showToast(this.translateService.instant('REPLACE_INVOICE_MODAL.cancelledSuccessfully'), 'success');

                this.goToCreateSale();
                this.invoicingService.clearAll();
                this.close();

                setTimeout(() => {
                  this.invoicingService.setPatient(patientCopy);
                  cartCopy?.saleLines.forEach((item) => {
                      const itemType = item.itemType;
                      const isBookingAppointment = item.bookingId ? true : false;
                      item['price'] = item.unitPriceCents / 100;
                      item['id'] = itemType === 'product' ? item.productId : item.serviceId;
                      this.invoicingService.addItemToCart(item, itemType, isBookingAppointment);
                  });
                }, 200);

            },
            error: (error) => {
                this.toastNotificationsService.showToast(error?.errMsg || this.translateService.instant('GENERAL.generalErrorMsg'), 'error');
                this.saving.set(false);
            },
        });

    }

    goToCreateSale() {
      this.router.navigateByUrl('/' + this.currentStore()?.slug + '/dashboard/redirect', { state: { redirectTo: '/' + this.currentStore()?.slug + '/dashboard/payment/create' } });
    }
}
